module.exports = __webpack_public_path__ + "img/Group3.ae0c11de.svg";